import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import { i18next, view, blocks } from '@yola/ws-sdk';
import Trigger from 'src/js/modules/common/components/trigger';
import segment from 'src/js/modules/analytics/segment';
import getClosestBlockElement from 'src/js/modules/common/helpers/get-closest-block-element';
import prefetchResource from 'yola-editor/src/js/utils/prefetch-resource';
import { useSelector } from 'react-redux';

const {
  Popover,
  PopoverTrigger,
  PopoverContent,
  Paragraph,
  Heading,
  Stack,
  Box,
  HorizontalStack,
  BetaLabel,
} = designSystem;
const {
  constants: { events },
  trackers: { trackEvent },
} = segment;

const popoverImage = '/images/composite-images.gif';

prefetchResource(popoverImage);

function TriggerWithUpgradePopover({ children, id, elementId = null }) {
  const scrollPosition = useSelector(view.selectors.getScrollPosition);

  useEffect(() => {
    Popover.hide();
  }, [scrollPosition]);

  const onPopoverHover = useCallback(() => {
    const liveElement = view.accessors.getLiveElement(elementId);
    const block = getClosestBlockElement(liveElement);
    const blockId = blocks.accessors.getBlockIdByElement(block);
    const blockVariationId = blocks.accessors.getVariationIdByElement(block);

    trackEvent(events.UPGRADE_POPOVER_SEEN, {
      premiumFeature: 'premium_composite_group',
      blockId,
      blockVariationId,
    });
  }, [elementId]);

  return (
    <Popover
      onHover={onPopoverHover}
      appearance="dark"
      mode="tooltip"
      placement="bottom-center"
      imgSrc={popoverImage}
      width={318}
    >
      <PopoverTrigger>
        <Trigger id={id}>{children}</Trigger>
      </PopoverTrigger>
      <PopoverContent>
        <Box paddingTop="spacing-3-xs">
          <Stack gap="spacing-3-xs">
            <HorizontalStack gap="spacing-3-xs" verticalAlign="center">
              <Heading type="heading-5" appearance="white">
                {i18next.t('Advanced image layouts')}
              </Heading>

              <div>
                <BetaLabel />
              </div>
            </HorizontalStack>
            <Paragraph appearance="low-emphasis">
              {i18next.t(
                'Combine images into multi-layered designs to captivate your audience with eye-catching, dynamic visuals'
              )}
            </Paragraph>
          </Stack>
        </Box>
      </PopoverContent>
    </Popover>
  );
}

TriggerWithUpgradePopover.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  elementId: PropTypes.string,
};

export default TriggerWithUpgradePopover;
